/** Portfolio aggregates cover every brand at once, so they are refetched on the
 *  same cadence rather than on every remount. Flag edits invalidate the assurance
 *  key directly, which is what keeps the safety roll-up current within the window. */
export const PORTFOLIO_STALE_TIME = 5 * 60 * 1000;
